import React from 'react';
import { SvgIcon } from '@mui/material';

export default function StarIcon(props) {
  return (
    <SvgIcon sx={{ width: 48, height: 48 }} {...props}>
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" fill="#4520AB" />
        <path
          d="M23.4751 6.45716C23.6401 5.94911 24.3589 5.94911 24.524 6.45716L27.8398 16.6623C28.1145 17.5076 28.9021 18.0798 29.7909 18.0798H40.5212C41.0554 18.0798 41.2775 18.7634 40.8453 19.0774L32.1643 25.3846C31.4453 25.9069 31.1444 26.8329 31.4191 27.6781L34.7349 37.8833C34.9 38.3914 34.3185 38.8138 33.8864 38.4998L25.2053 32.1927C24.4863 31.6703 23.5127 31.6703 22.7937 32.1927L14.1127 38.4998C13.6805 38.8138 13.099 38.3914 13.2641 37.8833L16.5799 27.6781C16.8546 26.8329 16.5537 25.9069 15.8347 25.3846L7.15368 19.0774C6.72151 18.7634 6.94361 18.0798 7.47781 18.0798H18.2082C19.0969 18.0798 19.8846 17.5076 20.1592 16.6623L23.4751 6.45716Z"
          stroke="white"
          strokeWidth="1.5"
        />
        <path
          opacity="0.5"
          d="M18.576 16.6389C21.1986 8.05275 22.7024 5.68021 23.2727 5.48262C23.3645 5.45079 23.4094 5.55683 23.3793 5.64928L22.5078 8.32817L19.6642 16.8769C19.6477 16.9268 19.6136 16.9689 19.5683 16.9955L18.2333 17.7798C18.2021 17.7982 18.1668 17.8084 18.1306 17.8096L14.9169 17.9167L10.5948 17.8078H8.03903C8.02353 17.8078 8.00808 17.8094 7.99294 17.8127L6.89237 18.052C6.81293 18.0693 6.74983 18.1295 6.72888 18.2081L6.64467 18.5238C6.62763 18.5877 6.58288 18.6428 6.51851 18.658C6.27635 18.7152 5.94758 18.6264 6.03629 17.9167C6.13799 17.1032 7.39828 16.7776 8.01571 16.7958C11.0546 16.7837 17.2775 16.7667 17.8587 16.7958C18.1214 16.8089 18.275 16.8102 18.3682 16.8076C18.4636 16.805 18.5481 16.7302 18.576 16.6389Z"
          fill="white"
        />
        <path
          d="M39.304 17.2669L27.1748 17.0176L30.5762 27.4819C32.8876 25.8786 39.4507 21.1422 41.4549 19.5957C41.9643 19.2027 42.5541 17.0006 39.304 17.2669Z"
          fill="#29EDFF"
        />
      </svg>
    </SvgIcon>
  );
}
